import React from "react";
import osAlignmentImage from "@/assets/images/fieldcoach-os-alignment.jpg";

const OSAlignmentBlock: React.FC = () => (
  <section
    className="relative overflow-hidden bg-secondary py-20"
    id="certainpath-os"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-[radial-gradient(45%_60%_at_85%_15%,rgba(178,0,48,.15),transparent_60%),radial-gradient(35%_45%_at_10%_85%,rgba(255,200,87,.05),transparent_60%)]"
    />

    <div className="relative z-10 mx-auto grid max-w-6xl grid-cols-1 items-center gap-11 px-8 md:grid-cols-[1fr_1.35fr]">
      <div className="aspect-[5/4] overflow-hidden rounded-2xl border border-white/10 shadow-2xl">
        <img
          alt="A home service professional reviewing coaching insights on a laptop"
          className="block h-full w-full object-cover"
          loading="lazy"
          src={osAlignmentImage}
        />
      </div>

      <div>
        <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-gold md:text-3xl">
          The only AI coaching platform aligned with the CertainPath Operating
          System.
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/90">
          FieldCoach is built around your CertainPath scripts, processes, and
          standards — out of the box. Every analytic, every coaching insight,
          every score is calibrated to how CertainPath members actually sell in
          the home.
        </p>
      </div>
    </div>
  </section>
);

export default OSAlignmentBlock;
